const SpeedGrade = ({ results, currentPhase }) => {
  if (currentPhase !== 'complete') return null;

  const getSpeedGrade = (speed) => {
    if (speed >= 100) return { grade: 'Excellent', color: 'text-[#1E9B4C] dark:text-green-400', bg: 'bg-[#1E9B4C]/20 dark:bg-green-500/20' };
    if (speed >= 50) return { grade: 'Very Good', color: 'text-[#1E9B4C] dark:text-green-400', bg: 'bg-[#1E9B4C]/15 dark:bg-green-500/15' };
    if (speed >= 25) return { grade: 'Good', color: 'text-[#1E9B4C] dark:text-green-400', bg: 'bg-[#1E9B4C]/10 dark:bg-green-500/10' };
    if (speed >= 10) return { grade: 'Fair', color: 'text-orange-500 dark:text-orange-400', bg: 'bg-orange-500/20 dark:bg-orange-500/20' };
    return { grade: 'Poor', color: 'text-red-500 dark:text-red-400', bg: 'bg-red-500/20 dark:bg-red-500/20' };
  };

  const downloadGrade = getSpeedGrade(results.downloadSpeed);

  return (
    <div className={`${downloadGrade.bg} rounded-2xl p-4 mb-6 border border-[#1E9B4C]/20 dark:border-green-500/20`}>
      <div className="flex items-center justify-between">
        <div>
          <div className={`text-lg font-bold ${downloadGrade.color}`}>
            {downloadGrade.grade} Connection
          </div>
          <div className="text-sm text-gray-600 dark:text-gray-300">
            Your connection is performing {downloadGrade.grade.toLowerCase()}
          </div>
        </div>
        <div className="text-3xl">
          {downloadGrade.grade === 'Excellent' && '🚀'}
          {downloadGrade.grade === 'Very Good' && '⚡'}
          {downloadGrade.grade === 'Good' && '👍'}
          {downloadGrade.grade === 'Fair' && '👌'}
          {downloadGrade.grade === 'Poor' && '😔'}
        </div>
      </div>
    </div>
  );
};
export default SpeedGrade;